import axios from 'axios';

const getTvChannels = (fetchTvChannelsUrl) =>
  axios.get(fetchTvChannelsUrl).then(({ data }) => data);

export default getTvChannels;
